<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  [dialogTitle]="'Manage Competencies (' + selectedCount + ' selected)'"
  [hideDefaultActions]="true"
  [guardUnsavedWork]="true"
>

<div crucibleDialogContent>
<!-- Filters -->
<div class="filter-section">
  @if (frameworkNames.length > 1) {
  <mat-form-field class="type-filter-field">
    <mat-label>Framework</mat-label>
    <mat-select [(value)]="frameworkFilter" (selectionChange)="onFilterChanged()">
      <mat-option value="">All Frameworks</mat-option>
      @for (fw of frameworkNames; track fw) {
      <mat-option [value]="fw">{{ fw }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
  @if (competencyTypes.length > 1) {
  <mat-form-field class="type-filter-field">
    <mat-label>Type</mat-label>
    <mat-select [(value)]="typeFilter" (selectionChange)="onFilterChanged()">
      <mat-option value="">All Types</mat-option>
      @for (t of competencyTypes; track t) {
      <mat-option [value]="t">{{ t }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
  <mat-form-field class="search-field">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchText" (ngModelChange)="onFilterChanged()" placeholder="Filter by ID, name, or description">
    @if (searchText) {
    <button matSuffix mat-icon-button (click)="searchText = ''" title="Clear search">
      <mat-icon fontIcon="mdi-close"></mat-icon>
    </button>
    }
  </mat-form-field>
</div>

@if (data.canEdit) {
<div class="action-buttons">
  <span class="selection-count">{{ selectedCount }} of {{ mselCompetencies.length }} selected{{ frameworkFilter || typeFilter || searchText ? ' (' + filteredCompetencies.length + ' shown)' : '' }}</span>
</div>
}

<!-- Competencies table -->
<div class="table-content">
  @if (mselCompetencies.length === 0) {
  <div class="loading-message">No competencies in this MSEL's pool. Add competencies from the Competencies tab first.</div>
  } @else {
  <table class="element-table">
    <thead>
      <tr>
        @if (data.canEdit) {
        <th class="check-column">
          <mat-checkbox
            [checked]="allFilteredSelected"
            [indeterminate]="someFilteredSelected"
            (change)="toggleAll()">
          </mat-checkbox>
        </th>
        }
        <th>ID</th>
        <th>Framework</th>
        <th>Type</th>
        <th>Name</th>
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      @for (mc of paginatedCompetencies; track mc.competency?.idNumber) {
      <tr (click)="data.canEdit && toggleCompetency(mc)" [class.clickable-row]="data.canEdit" [class.selected-row]="isSelected(mc)">
        @if (data.canEdit) {
        <td class="check-column">
          <mat-checkbox
            [checked]="isSelected(mc)"
            (click)="$event.stopPropagation()"
            (change)="toggleCompetency(mc)">
          </mat-checkbox>
        </td>
        }
        <td class="id-column">{{ mc.competency?.idNumber }}</td>
        <td class="framework-column">{{ getFramework(mc) }}</td>
        <td class="type-column">{{ getType(mc) }}</td>
        <td>{{ mc.competency?.shortName }}</td>
        <td class="description-column">{{ mc.competency?.description }}</td>
      </tr>
      }
    </tbody>
  </table>
  }
</div>
<mat-paginator
  [length]="filteredCompetencies.length"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [pageSizeOptions]="[25, 50, 100, 250]"
  (page)="onPageChanged($event)"
  showFirstLastButtons>
</mat-paginator>
</div>

<ng-container crucibleDialogActions>
  <button matButton="filled" type="button" (click)="handleClose()">Close</button>
</ng-container>
</crucible-dialog>
